import name from './name'

const selectSliceData = state => state[name]

const selectSkillBite = state => selectSliceData(state).skillBite

export { selectSkillBite }
